export default __webpack_public_path__ + "static/media/platinum hat.4393ed1c.svg";